import { useState } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/payrollActions";

import { PencilIcon } from "@heroicons/react/20/solid";

const PayslipNote = ({ employeeID, note, toAdvisor, noteToAdvisor, showByDefault, ready, payrollUpdateNote }) => {
	const [showNote, setShowNote] = useState((toAdvisor ? noteToAdvisor : note) ? true : false);

	if (showNote) {
		return (
			<div style={{ gridColumn: "span 6 / span 6" }}>
				<label style={{ marginTop: 6 }}>{toAdvisor ? "Note to Advisor" : "Custom Payslip Note"}</label>
				<textarea
					disabled={ready}
					className="form-input"
					style={{ minHeight: 100 }}
					onChange={(e) => {
						!ready &&
							payrollUpdateNote({
								[toAdvisor ? "toAdvisor" : "note"]: e.target.value,
								employeeID,
							});
					}}
				>
					{toAdvisor ? noteToAdvisor : note}
				</textarea>
			</div>
		);
	}

	return (
		<div style={{ gridColumnStart: "4", gridColumnEnd: "7" }}>
			<button
				style={{ lineHeight: "38px", marginBottom: 10, marginRight: 10 }}
				className="btn btn-xs btn-default pull-right"
				type="button"
				data-toggle="tooltip"
				title="Add or Deduct"
				disabled={ready}
				onClick={() => {
					if (!ready) {
						payrollUpdateNote({
							note: " ",
							employeeID,
						});
						setShowNote(true);
					}
				}}
			>
				<PencilIcon
					className="w-6 h-6 mr-3"
					style={{ verticalAlign: "text-bottom" }}
				/>
				Add {toAdvisor ? "Note to Advisor" : "Payslip Note"}
			</button>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	console.log("state", state && state.grades);
	const employee =
		state.payroll &&
		state.payroll.employees &&
		state.payroll.employees.find((employee) => employee.id == ownProps.employeeID);

	const payslip = employee.payslip;
	// const { ready } = payslip ?? {};
	const note = employee?.note ?? payslip?.note ?? null;
	const toAdvisor = employee?.toAdvisor ?? payslip?.toAdvisor ?? null;

	return {
		note,
		noteToAdvisor: toAdvisor,
		employeeID: ownProps.employeeID,
	};
};

const mapDispatchToProps = (dispatch) => ({
	payrollUpdateNote: ({ employeeID, note, toAdvisor }) => dispatch(ACTIONS.payrollUpdateNote({ employeeID, note, toAdvisor })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayslipNote);
